<template>
  <div class="rightContent">
    <div class="right-con">
      <!--创建问卷-->
      <el-scrollbar style="height: 100%" ref="scrollbarRef">
        <!--问卷预览--已结束-->
        <div class="questionnaire-view">
          <div v-if="type == 'stop'" class="fl-right font-12">
            {{$t('showInfo.答题人数')}}:<font class="font-red">{{ itemNum }}</font
            >{{$t('showInfo.人')}}
          </div>
          <h1 class="border-f1">
            <img src="../../../svg/forceanswer.svg" v-show="forceAnswer" class="forceanswer-icon">
            <span>{{ title }}</span>
          </h1>
          <div
            class="question-item"
            v-for="(item, sub) in dataList"
            :key="'Data' + sub"
          >
            <div>
              <h2>
                <span>{{ sub + 1 }}.</span><span style="color:#EA494B;font-size: 16px;">{{ item.force ? '*':'' }}</span>
                <template v-if="item.questionType">
                  【{{ $t(`showInfo.${item.questionType}`) }}】
                </template>
                <template v-else> 【{{ options[item.type] }}】 </template>
                {{ item.title }}
                <a
                  v-if="
                    questionNaireState == 2 &&
                    item.questionType === '问答' &&
                    answerPeopleCount > 0
                  "
                  href="javascript:;"
                  @click="toDetail(item, sub)"
                  class="detail"
                  >{{$t('showInfo.详细')}}</a
                >
              </h2>
              <!-- 普通问卷-->
              <ul class="question" v-if="item.scaleType <= 0">
                <li v-for="(items, number) in item.options" :key="number">
                  <span class="item-question" :class="{'item-question-circle': item.scaleType == 0}">
                    <span v-if="item.scaleType < 0" style="margin-right: 5px"
                      >{{ items.number }}:</span
                    ><span
                      v-else
                      style="margin-right: 5px"
                      class="scale-type"
                    ></span
                    >{{ items.item }}
                    <div v-if="items.completion" class="requiredTips">
                        <span v-if="items.required"><span style="color: #EA494B;">*</span>{{$t('answerList.必填')}}</span>
                        <span v-else>{{$t('answerList.选填')}}</span>
                      </div>
                    </span
                  >
                
                </li>
                <li
                  v-for="(items, number) in item.optionsStatistics"
                  :key="number"
                >
                  <span
                    class="item-question item-question-answer"
                    :style="{ backgroundSize: `${items.percent}% 100%` }"
                    ><span class="answer-content"
                      ><span v-if="item.scaleType < 0" style="margin-right: 5px"
                        >{{ items.number }}:</span
                      >{{ items.item }}</span
                    >   <div v-if="items.completion" class="requiredTips">
                        <span v-if="items.required"><span style="color: #EA494B;">*</span>{{$t('answerList.必填')}}</span>
                        <span v-else>{{$t('answerList.选填')}}</span>
                      </div>
                    </span
                  >
                  <!-- <span class="item-question-answer"></span> -->
                  <span class="item-answer"
                    >{{ items.selectCount }}{{$t('showInfo.人')}}（{{ items.percent }}%）</span
                  >
                  <a
                    v-if="questionNaireState == 2 && items.completion"
                    href="javascript:;"
                    @click="toDetailItem(items, sub)"
                    class="detail-item"
                    >{{$t('showInfo.详细')}}</a
                  >
                </li>
              </ul>
              <!-- 未发布量表题 -->
              <div
                v-if="questionNaireState == 0 && item.scaleType > 0"
                class="scale-item"
              >
                <div class="scale-item-title">
                  <span class="scale-item-left">
                    {{ item.options[0].item }}
                  </span>
                  <span>
                    {{ item.options[item.options.length - 1].item }}
                  </span>
                </div>
                <div class="scale-item-content">
                  <div
                    v-for="(o, index) in item.options"
                    :key="index"
                    class="scale-item-other"
                    :class="{ 'scale-item-row': item.scaleType == 4 }"
                  >
                    <template v-if="item.scaleType == 1">
                      <img
                        :src="require('@/svg/star-question.svg')"
                        width="16px"
                        height="16px"
                      />
                    </template>
                    <template v-if="item.scaleType == 2">
                      <img
                        :src="require('@/svg/heart-question.svg')"
                        width="16px"
                        height="16px"
                      />
                    </template>
                    <template v-if="item.scaleType == 3">
                      <img
                        :src="require('@/svg/prise-question.svg')"
                        width="16px"
                        height="16px"
                      />
                    </template>

                    <span
                      class="scale-item-score"
                      v-if="item.scaleType == 4"
                      :class="{
                        'scale-item-end': index + 1 === item.options.length,
                        'scale-item-start': index === 0,
                      }"
                      >{{ index + 1 }}</span
                    >
                  </div>
                </div>
              </div>
              <!-- 已发布量表题 -->
              <ul
                class="question"
                v-if="questionNaireState != 0 && item.scaleType > 0"
              >
                <!-- 无答题结果的量表题 -->
                <li v-for="(items, number) in item.options" :key="number">
                  <span class="item-question">
                    <template v-if="item.scaleType == 1">
                      <svg   v-for="index of number + 1"
                        :key="index" width="16px" height="15px" viewBox="0 0 16 15" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                        <title>路径</title>
                        <desc>Created with Sketch.</desc>
                        <g id="主播端" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                            <g id="新增量表题-发布中" transform="translate(-487.000000, -237.000000)" class="main-color" fill="#3986EE" fill-rule="nonzero">
                                <g id="编组-3" transform="translate(282.000000, 66.000000)">
                                    <path d="M217.220796,180.631444 C217.401519,181.471272 217.56098,182.231369 217.699179,182.911743 C217.762963,183.198773 217.821432,183.485802 217.874586,183.772832 C217.927739,184.059862 217.978235,184.320315 218.026074,184.554191 C218.073912,184.788066 218.113777,184.987393 218.145669,185.152169 C218.177561,185.316946 218.198823,185.420596 218.209454,185.463117 C218.241346,185.675732 218.193508,185.816589 218.065939,185.885689 C217.93837,185.954789 217.794856,185.989339 217.635395,185.989339 C217.582241,185.989339 217.505168,185.970735 217.404177,185.933528 C217.303185,185.89632 217.226113,185.867085 217.172959,185.845824 L213.011031,183.422015 C212.256249,183.868507 211.570567,184.267159 210.95398,184.617972 C210.688211,184.766803 210.4251,184.915633 210.164647,185.064464 C209.904194,185.213294 209.667661,185.351494 209.455045,185.479062 C209.242431,185.60663 209.059051,185.712937 208.904904,185.797984 C208.750758,185.883029 208.647109,185.936183 208.593956,185.957444 C208.487648,186.010598 208.378684,186.029202 208.26706,186.013256 C208.155438,185.99731 208.054446,185.957444 207.964084,185.89366 C207.873723,185.829876 207.807281,185.752803 207.764758,185.662442 C207.722235,185.572081 207.711604,185.479062 207.732866,185.383386 C207.743497,185.340863 207.770073,185.237213 207.812596,185.072438 C207.855119,184.907661 207.902958,184.710993 207.956111,184.482431 C208.009265,184.25387 208.070392,184.00139 208.139492,183.724992 C208.208591,183.448593 208.280349,183.166878 208.354763,182.879848 C208.514224,182.220743 208.694947,181.476591 208.896931,180.647392 C208.269717,180.105224 207.706288,179.621526 207.206638,179.196298 C206.994023,179.015575 206.784066,178.837511 206.576766,178.662104 C206.369466,178.486697 206.183429,178.327236 206.018653,178.183721 C205.853876,178.040206 205.718334,177.923268 205.612027,177.832908 C205.505719,177.742546 205.44725,177.69205 205.43662,177.68142 C205.309051,177.564482 205.200086,177.434255 205.109724,177.290741 C205.019363,177.147226 204.984813,177.001053 205.006075,176.852224 C205.027336,176.703393 205.085805,176.586455 205.181481,176.50141 C205.277158,176.416364 205.383466,176.363211 205.500403,176.341949 L210.427742,175.895458 L212.261546,171.621898 C212.32533,171.451807 212.415691,171.305634 212.532629,171.18338 C212.649567,171.061127 212.809027,171 213.011012,171 C213.117319,171 213.210338,171.023919 213.290068,171.071757 C213.369799,171.119596 213.436241,171.175407 213.489394,171.239192 C213.542548,171.302976 213.587729,171.366761 213.624936,171.430545 C213.662144,171.494329 213.691378,171.547483 213.71264,171.590005 L215.498601,175.863565 L220.42594,176.326002 C220.638554,176.379156 220.787385,176.442941 220.872431,176.517355 C220.957477,176.59177 221,176.708707 221,176.868168 C221,177.016999 220.954819,177.147225 220.864458,177.258847 C220.774097,177.37047 220.659816,177.506012 220.521617,177.665473 L217.220796,180.631444 Z" id="路径"></path>
                                </g>
                            </g>
                        </g>
                    </svg>
                    </template>
                    <template v-if="item.scaleType == 2">
                      <svg    v-for="index of number + 1"
                        :key="index" width="16px" height="13px" viewBox="0 0 16 13" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                          <title>爱心</title>
                          <desc>Created with Sketch.</desc>
                          <g id="主播端" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                              <g id="新增量表题-发布中" transform="translate(-1001.000000, -247.000000)" class="main-color" fill="#3986EE" fill-rule="nonzero">
                                  <path d="M1001,251.576634 L1001,251.576529 C1001,249.048982 1003.04898,247 1005.57653,247 C1006.81233,247 1007.9956,247.499775 1008.85723,248.385659 L1008.85723,248.385659 C1010.61954,246.573816 1013.51697,246.533679 1015.32881,248.295982 C1016.21467,249.157632 1016.71441,250.340921 1016.71441,251.576703 L1016.71441,251.576756 C1016.71793,253.026456 1016.03088,254.391188 1014.86425,255.251791 L1009.6853,259.519158 L1009.6853,259.519158 C1009.09049,260.009451 1008.22787,259.995917 1007.64873,259.487206 L1002.60444,255.056296 L1002.60444,255.056296 C1001.58534,254.187728 1000.9988,252.915647 1001,251.576625 L1001,251.576634 Z" id="爱心"></path>
                              </g>
                          </g>
                      </svg>
                    </template>
                    <template v-if="item.scaleType == 3">
                      <svg    v-for="index of number + 1"
                        :key="index" width="16px" height="16px" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                          <title>点赞</title>
                          <desc>Created with Sketch.</desc>
                          <g id="主播端" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                              <g id="新增量表题-发布中" transform="translate(-1001.000000, -280.000000)" class="main-color" fill="#3986EE" fill-rule="nonzero">
                                  <path d="M1013.03312,295.275525 L1013.01082,295.275525 C1012.31961,295.268092 1011.62653,295.268092 1010.93346,295.268092 L1009.87619,295.268092 C1009.17011,295.268092 1008.46403,295.268092 1007.75609,295.258802 C1007.36403,295.247653 1006.97754,295.165896 1006.61335,295.017247 C1005.9946,294.775693 1005.64156,294.236841 1005.64341,293.536333 L1005.64528,290.908965 C1005.64528,289.454065 1005.64528,287.997307 1005.65828,286.542406 C1005.66014,286.146629 1005.9147,285.775007 1006.1321,285.579905 C1006.97382,284.810647 1007.88801,283.851863 1008.27079,282.558618 C1008.3767,282.198144 1008.41758,281.800509 1008.46031,281.380576 C1008.54579,280.544426 1009.08835,280 1009.81302,280 C1010.09731,280 1010.3816,280.085473 1010.66032,280.250845 C1011.21961,280.587163 1011.59309,281.114866 1011.79934,281.867401 C1012.13008,283.062166 1011.96099,284.221627 1011.77518,285.215716 L1011.77518,285.219432 C1011.73244,285.451696 1011.90711,285.667236 1012.14495,285.667236 L1014.56049,285.667236 C1014.97671,285.667236 1015.57316,285.719263 1015.94106,286.16521 C1016.20863,286.490379 1016.28482,286.928893 1016.17147,287.508624 C1015.82586,289.290551 1015.40221,291.087344 1014.99714,292.761501 C1014.87079,293.28363 1014.66083,293.766739 1014.45829,294.234983 L1014.37096,294.435659 C1014.14056,294.978227 1013.66488,295.275525 1013.03312,295.275525 L1013.03312,295.275525 Z M1002.67416,295.100862 L1002.45304,295.100862 C1001.65405,295.100862 1001,294.446807 1001,293.64782 L1001,287.172306 C1001,286.373318 1001.65405,285.719263 1002.45304,285.719263 L1002.67416,285.719263 C1003.47314,285.719263 1004.1272,286.373318 1004.1272,287.172306 L1004.1272,293.645962 C1004.12906,294.446807 1003.475,295.100862 1002.67416,295.100862 L1002.67416,295.100862 Z" id="点赞"></path>
                              </g>
                          </g>
                      </svg>
                    </template>
                    <template v-if="item.scaleType == 4">
                      <span>{{ number + 1 }}</span>
                    </template>
                  </span>
                </li>
                <!-- 有答题结果的量表题 -->
                <li
                  v-for="(items, number) in item.optionsStatistics"
                  :key="number"
                >
                  <span
                    class="item-question item-question-answer"
                    :style="{ backgroundSize: `${items.percent}% 100%` }"
                  >
                    <template v-if="item.scaleType == 1">
                      <svg    v-for="index of number + 1"
                        :key="index"
                        style="margin-right:4px" width="16px" height="15px" viewBox="0 0 16 15" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                        <!-- Generator: Sketch 61 (89581) - https://sketch.com -->
                        <title>路径</title>
                        <desc>Created with Sketch.</desc>
                        <g id="主播端" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                            <g id="新增量表题-发布中" transform="translate(-487.000000, -237.000000)" class="main-color" fill="#3986EE" fill-rule="nonzero">
                                <g id="编组-3" transform="translate(282.000000, 66.000000)">
                                    <path d="M217.220796,180.631444 C217.401519,181.471272 217.56098,182.231369 217.699179,182.911743 C217.762963,183.198773 217.821432,183.485802 217.874586,183.772832 C217.927739,184.059862 217.978235,184.320315 218.026074,184.554191 C218.073912,184.788066 218.113777,184.987393 218.145669,185.152169 C218.177561,185.316946 218.198823,185.420596 218.209454,185.463117 C218.241346,185.675732 218.193508,185.816589 218.065939,185.885689 C217.93837,185.954789 217.794856,185.989339 217.635395,185.989339 C217.582241,185.989339 217.505168,185.970735 217.404177,185.933528 C217.303185,185.89632 217.226113,185.867085 217.172959,185.845824 L213.011031,183.422015 C212.256249,183.868507 211.570567,184.267159 210.95398,184.617972 C210.688211,184.766803 210.4251,184.915633 210.164647,185.064464 C209.904194,185.213294 209.667661,185.351494 209.455045,185.479062 C209.242431,185.60663 209.059051,185.712937 208.904904,185.797984 C208.750758,185.883029 208.647109,185.936183 208.593956,185.957444 C208.487648,186.010598 208.378684,186.029202 208.26706,186.013256 C208.155438,185.99731 208.054446,185.957444 207.964084,185.89366 C207.873723,185.829876 207.807281,185.752803 207.764758,185.662442 C207.722235,185.572081 207.711604,185.479062 207.732866,185.383386 C207.743497,185.340863 207.770073,185.237213 207.812596,185.072438 C207.855119,184.907661 207.902958,184.710993 207.956111,184.482431 C208.009265,184.25387 208.070392,184.00139 208.139492,183.724992 C208.208591,183.448593 208.280349,183.166878 208.354763,182.879848 C208.514224,182.220743 208.694947,181.476591 208.896931,180.647392 C208.269717,180.105224 207.706288,179.621526 207.206638,179.196298 C206.994023,179.015575 206.784066,178.837511 206.576766,178.662104 C206.369466,178.486697 206.183429,178.327236 206.018653,178.183721 C205.853876,178.040206 205.718334,177.923268 205.612027,177.832908 C205.505719,177.742546 205.44725,177.69205 205.43662,177.68142 C205.309051,177.564482 205.200086,177.434255 205.109724,177.290741 C205.019363,177.147226 204.984813,177.001053 205.006075,176.852224 C205.027336,176.703393 205.085805,176.586455 205.181481,176.50141 C205.277158,176.416364 205.383466,176.363211 205.500403,176.341949 L210.427742,175.895458 L212.261546,171.621898 C212.32533,171.451807 212.415691,171.305634 212.532629,171.18338 C212.649567,171.061127 212.809027,171 213.011012,171 C213.117319,171 213.210338,171.023919 213.290068,171.071757 C213.369799,171.119596 213.436241,171.175407 213.489394,171.239192 C213.542548,171.302976 213.587729,171.366761 213.624936,171.430545 C213.662144,171.494329 213.691378,171.547483 213.71264,171.590005 L215.498601,175.863565 L220.42594,176.326002 C220.638554,176.379156 220.787385,176.442941 220.872431,176.517355 C220.957477,176.59177 221,176.708707 221,176.868168 C221,177.016999 220.954819,177.147225 220.864458,177.258847 C220.774097,177.37047 220.659816,177.506012 220.521617,177.665473 L217.220796,180.631444 Z" id="路径"></path>
                                </g>
                            </g>
                        </g>
                    </svg>
                    </template>
                    <template v-if="item.scaleType == 2">
                      <svg   v-for="index of number + 1"
                        :key="index"
                        style="margin-right:4px" width="16px" height="13px" viewBox="0 0 16 13" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                          <title>爱心</title>
                          <desc>Created with Sketch.</desc>
                          <g id="主播端" stroke="none" stroke-width="1"  fill="none" fill-rule="evenodd">
                              <g id="新增量表题-发布中" transform="translate(-1001.000000, -247.000000)"   class="main-color" fill="#3986EE" fill-rule="nonzero">
                                  <path d="M1001,251.576634 L1001,251.576529 C1001,249.048982 1003.04898,247 1005.57653,247 C1006.81233,247 1007.9956,247.499775 1008.85723,248.385659 L1008.85723,248.385659 C1010.61954,246.573816 1013.51697,246.533679 1015.32881,248.295982 C1016.21467,249.157632 1016.71441,250.340921 1016.71441,251.576703 L1016.71441,251.576756 C1016.71793,253.026456 1016.03088,254.391188 1014.86425,255.251791 L1009.6853,259.519158 L1009.6853,259.519158 C1009.09049,260.009451 1008.22787,259.995917 1007.64873,259.487206 L1002.60444,255.056296 L1002.60444,255.056296 C1001.58534,254.187728 1000.9988,252.915647 1001,251.576625 L1001,251.576634 Z" id="爱心"></path>
                              </g>
                          </g>
                      </svg>
                    </template>
                    <template v-if="item.scaleType == 3">
                      <svg        v-for="index of number + 1"
                        :key="index"
                        style="margin-right:4px" width="16px" height="16px" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                          <title>点赞</title>
                          <desc>Created with Sketch.</desc>
                          <g id="主播端" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                              <g id="新增量表题-发布中" transform="translate(-1001.000000, -280.000000)" class="main-color" fill="#3986EE" fill-rule="nonzero">
                                  <path d="M1013.03312,295.275525 L1013.01082,295.275525 C1012.31961,295.268092 1011.62653,295.268092 1010.93346,295.268092 L1009.87619,295.268092 C1009.17011,295.268092 1008.46403,295.268092 1007.75609,295.258802 C1007.36403,295.247653 1006.97754,295.165896 1006.61335,295.017247 C1005.9946,294.775693 1005.64156,294.236841 1005.64341,293.536333 L1005.64528,290.908965 C1005.64528,289.454065 1005.64528,287.997307 1005.65828,286.542406 C1005.66014,286.146629 1005.9147,285.775007 1006.1321,285.579905 C1006.97382,284.810647 1007.88801,283.851863 1008.27079,282.558618 C1008.3767,282.198144 1008.41758,281.800509 1008.46031,281.380576 C1008.54579,280.544426 1009.08835,280 1009.81302,280 C1010.09731,280 1010.3816,280.085473 1010.66032,280.250845 C1011.21961,280.587163 1011.59309,281.114866 1011.79934,281.867401 C1012.13008,283.062166 1011.96099,284.221627 1011.77518,285.215716 L1011.77518,285.219432 C1011.73244,285.451696 1011.90711,285.667236 1012.14495,285.667236 L1014.56049,285.667236 C1014.97671,285.667236 1015.57316,285.719263 1015.94106,286.16521 C1016.20863,286.490379 1016.28482,286.928893 1016.17147,287.508624 C1015.82586,289.290551 1015.40221,291.087344 1014.99714,292.761501 C1014.87079,293.28363 1014.66083,293.766739 1014.45829,294.234983 L1014.37096,294.435659 C1014.14056,294.978227 1013.66488,295.275525 1013.03312,295.275525 L1013.03312,295.275525 Z M1002.67416,295.100862 L1002.45304,295.100862 C1001.65405,295.100862 1001,294.446807 1001,293.64782 L1001,287.172306 C1001,286.373318 1001.65405,285.719263 1002.45304,285.719263 L1002.67416,285.719263 C1003.47314,285.719263 1004.1272,286.373318 1004.1272,287.172306 L1004.1272,293.645962 C1004.12906,294.446807 1003.475,295.100862 1002.67416,295.100862 L1002.67416,295.100862 Z" id="点赞"></path>
                              </g>
                          </g>
                      </svg>
                    </template>
                    <template v-if="item.scaleType == 4">
                      <span>{{ number + 1 }}</span>
                    </template>
                  </span>
                  <span class="item-answer"
                    >{{ items.selectCount }}{{$t('showInfo.人')}}（{{ items.percent }}%）</span
                  >
                </li>
              </ul>
            </div>
          </div>
          <div v-if="paperType == 1" class="third-answer">
            <span class="url">URL:</span
            ><span class="url-content">{{ thirdPartyPaperUri }}</span>
          </div>
        </div>
      </el-scrollbar>
    </div>
    <div class="bottom-bar">
      <el-divider class="bottom-divider"></el-divider>
      <div class="questionnaire-control">
        <div class="new">
          <div v-if="questionNaireState == 0">
            <template>
              <el-popover
                placement="top"
                width="180"
                v-model="visibleDel"
                height="160"
              >
                <p>
                  <img
                    src="../../../svg/icon-tips.svg"
                    width="15px"
                    height="15px"
                  />{{$t('showInfo.确定删除这份问卷吗')}}
                </p>
                <div style="text-align: right; margin: 0">
                  <el-button size="mini" type="text" @click="visibleDel = false"
                    >{{$t('showInfo.取消')}}</el-button
                  >
                  <el-button
                    type="primary"
                    size="mini"
                    @click="deletQuestionnaireApiFunc"
                    >{{$t('showInfo.确定')}}</el-button
                  >
                </div>
                <a
                  slot="reference"
                  class="btn-sm btn-red-outline btn-modal-reconfirm"
                  >{{$t('showInfo.删除')}}</a
                >
              </el-popover>
            </template>
            <a class="btn-sm btn-blue-outline" @click="editQuestionnaire"
              >{{$t('showInfo.编辑')}}</a
            >
            <el-button
              class="btn-sm btn-blue-publish m-r-16"
              @click="releaseQuestionnaireFunc"
              :loading="publishLoading"
              >{{$t('showInfo.发布问卷')}}</el-button
            >
          </div>
          <div class="end" v-if="questionNaireState == 2">
            <span>
              {{$t('showInfo.共发放')}}<font class="font-blue">{{ paperCount }}</font
              >{{$t('showInfo.份')}}
            </span>
            <span class="font-12 m-r-8" style="margin-left: 10px"
              >{{$t('showInfo.已提交')}}<font class="font-blue">{{ answerPeopleCount }}</font
              >{{$t('showInfo.份问卷')}}</span
            >
            <span class="font-12 m-r-8" style="margin-left: 10px"
              >{{$t('showInfo.提交率')}}<font class="font-blue"
                >{{
                  paperCount > 0
                    ? Math.round((answerPeopleCount / paperCount) * 10000) / 100
                    : 0
                }}%</font
              ></span
            >
            <!-- <template>
              <el-popover
                placement="top"
                width="180"
                v-model="visibleDel"
                height="160"
              >
                <p>{{$t('showInfo.确定删除这份问卷吗？')}}</p>
                <div style="text-align: right; margin: 0">
                  <el-button size="mini" type="text" @click="visibleDel = false"
                    >{{$t('showInfo.取消')}}</el-button
                  >
                  <el-button
                    type="primary"
                    size="mini"
                    @click="deletQuestionnaireApiFunc"
                    >{{$t('showInfo.确定')}}</el-button
                  >
                </div>
                <a
                  slot="reference"
                  class="btn-sm btn-red-outline btn-modal-reconfirm"
                  >{{$t('showInfo.删除')}}</a
                >
              </el-popover>
            </template> -->
          </div>
          <div v-if="questionNaireState == 1" class="end">
            <!-- <span>
              共发放<font>{{ paperCount }}</font>份
            </span> -->
            <span class="font-12 m-r-8"
              >{{$t('showInfo.已提交')}}<font class="font-blue">{{ answerPeopleCount }}</font
              >{{$t('showInfo.份问卷')}}</span
            >
            <template>
              <el-popover
                placement="top"
                width="180"
                v-model="visibleFinish"
                height="160"
              >
                <p>{{$t('showInfo.确定结束这份问卷吗')}}</p>
                <div style="text-align: right; margin: 0">
                  <el-button
                    size="mini"
                    type="text"
                    @click="visibleFinish = false"
                    >{{$t('showInfo.取消')}}</el-button
                  >
                  <el-button
                    type="primary"
                    size="mini"
                    @click="finishReleaseApiFunc"
                    >{{$t('showInfo.确定')}}</el-button
                  >
                </div>
                <a
                  slot="reference"
                  class="btn-sm btn-red-finish btn-modal-reconfirm"
                  >{{$t('showInfo.结束发布')}}</a
                >
              </el-popover>
            </template>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      custom-class="dialog-detail dialog-dark"
      :visible.sync="detailShow"
      append-to-body
      :title="titleDetail"
      width="600px"
      height="480px"
    >
      <Detail
        :conf-id="confPaperId"
        :option="option"
        :question-num="questionNum"
        :type="questionType"
        v-if="detailShow"
      ></Detail>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
import { pushRoomMessageFunc } from "@/utils/socketMessageDispose";
import {
  getPaperInfo,
  finishReleaseApi,
  getConfPaperId,
  deletQuestionnaireApi,
  releaseQuestionnaire,
} from "@/api/liveRequest/questionnaireApi";
import Detail from "@/components/toolList/questionnaire/detail.vue";
export default {
  inject: ["questionThis"],
  props: {
    actionTabsObj: {
      type: Object,
      default: () => {
        return null;
      },
    },
    showInfoState: {
      type: Boolean,
      default: false,
    },
    answerId: {
      type: String,
      default: "",
    },
    paperId: {
      type: String,
      default: "",
    },
    action: {
      type: String,
      default: "",
    }
  },
  components: {
    Detail,
  },
  watch: {
    answerId: {
      immediate: true,
      handler(value) {
        if (value) {
          this.confId = value;
          if (value != "0") {
            this.confPaperId = this.paperId;
            console.log(value, " value");
            console.log(this.action,"watch getConfPaperIdFunc");
            //if(this.action == value){
              if(this.paperId != "0"){
                this.getConfPaperIdFunc();
              }else{
                this.getPaperInfoFunc();
              }
           // } 
          } 
          // else {
          //   this.getPaperInfoFunc();
          // }
        }
      },
    },
  },
  data() {
    return {
      itemNum: 0, //答题人数
      dataList: [],
      type: "",
      title: "",
      options: {
        0: this.$t('showInfo.单选'),
        1: this.$t('showInfo.多选'),
        2: this.$t('showInfo.问答'),
        5: this.$t('showInfo.量表'),
      },
      hintDialogVisible: false,
      hintState: "",
      loadingState: false,
      questionNaireState: "0",
      answerPeopleCount: 0,
      confPaperId: "",
      confId: "",
      firstRelease: true,
      visibleDel: false,
      visibleFinish: false,
      editPaperObject: {},
      paperCount: 0,
      detailShow: false,
      option: "",
      questionNum: -1,
      titleDetail: this.$t('showInfo.问答题详情'),
      questionType: "",
      publishLoading: false,
      paperType: 0,
      thirdPartyPaperUri: "",
      forceAnswer:false,//强制作答
    };
  },
  computed: {
    liveToken() {
      return this.$store.getters.liveToken;
    },
    liveId() {
      return this.$store.getters.liveId;
    },
    liveStartStatus() {
      return this.$store.getters.liveRoomStatus;
    },
  },
  mounted() {
    //收到聊天室消息
    pushRoomMessageFunc((msg) => {
      this.getCvMcRoomMessage(msg);
    });
  },
  methods: {
    toDetail(item, number) {
      console.log(item, "问答item");
      this.detailShow = true;
      this.option = item.questionId;
      this.titleDetail = this.$t('showInfo.问答题详情');
      this.questionNum = number + 1;
      this.questionType = this.$t('showInfo.问答');
    },
    toDetailItem(item, number) {
      this.titleDetail = this.$t('showInfo.填空题详情');
      this.detailShow = true;
      console.log(item, "item");
      this.option = item.number;
      this.questionNum = number + 1;
      this.questionType = "";
      // console.log(item, "item");
    },
    getCvMcRoomMessage(msg) {
      switch (msg.cmd) {
        case 7127: {
          this.disposeCustomMessage_7127(msg.requestData);
          break;
        }
        case 7107: {
          this.disposeCustomMessage_7107(msg.requestData);
          break;
        }
      }
    },
    disposeCustomMessage_7107(requestData) {
      if (requestData.event) {
        switch (requestData.event) {
          case "paper/state": {
            //console.log("7107问卷-------请求7107", requestData);
            console.log(this.action,"action");
            console.log(requestData.id,"7107 getConfPaperIdFunc");
            if(this.action == requestData.id || this.action == requestData.confPaperId){
              this.confPaperId = requestData.confPaperId;
              this.$emit("refreshList", true);
              this.questionNaireState = requestData.stateV2;
              this.getConfPaperIdFunc();
            }else{
              this.$emit("refresh");
            }
            break;
          }
        }
      }
    },
    /**处理7127消息内容体 */
    disposeCustomMessage_7127(requestData) {
      if (requestData.event) {
        switch (requestData.event) {
          case "paper/state": {
            //console.log("7127问卷-------请求7127", requestData);
            // this.confPaperId = requestData.confPaperId;
            if (requestData.state === "3") {
              console.log(this.action,"7127 getConfPaperIdFunc")
              if(this.action == requestData.confPaperId || this.action == requestData.id){
                this.getConfPaperIdFunc();
                this.firstRelease = false;
              } 
            }
            break;
          }
        }
      }
    },
    /** 初始化查看界面 */
    init() {
      if (this.showInfoState && this.actionTabsObj) {
        this.confId = this.actionTabsObj.id;
        //console.log(this.actionTabsObj.confPaperId);
        if (`${this.actionTabsObj.confPaperId}` === "0") {
          this.getPaperInfoFunc();
        } else {
          this.confPaperId = this.actionTabsObj.confPaperId;
          console.log("init getConfPaperIdFunc");
          this.getConfPaperIdFunc();
        }
      }
    },
    /**下载模板 */
    downloadFunc() {
      axios({
        url: `${process.env.VUE_APP_BASE_API}handler/v1/paper//export/${this.confPaperId}`,
        responseType: "arraybuffer",
        method: "get",
      })
        .then((res) => {
          console.log(res, "downloadFunc");
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement("a");
          link.style.display = "none";
          link.href = url;
          link.setAttribute("download", this.$t('showInfo.问卷结果') + ".xlsx");
          document.body.appendChild(link);
          link.click();
        })
        .catch((err) => {
          console.log(err);
          this.$message.error(this.$t('showInfo.文件下载失败'));
        });
    },
    /** 获取问卷统计信息 */
    getConfPaperIdFunc() {
      console.log("confPaperId", this.confPaperId);
      //this.loadingState = true;
      if(this.confPaperId === ""){
        return;
      }
      getConfPaperId(
        {
          confPaperId: this.confPaperId,
        },
        this.$store.getters.liveToken
      )
        .then((res) => {
          console.log(res, "getConfPaperId");
          if (res.code === 200) {
            let _data = res.data;
            this.title = _data.title;
            this.questionNaireState = _data.stateV2;
            this.answerPeopleCount = _data.answerPeopleCount;
            this.dataList = _data.questionStatistics;
            this.thirdPartyPaperUri = _data.thirdPartyPaperUri;
            this.paperType = _data.paperType;
            this.confPaperId = _data.confPaperId;
            this.paperCount = _data.paperCount;
            this.forceAnswer = _data.forceAnswer
          } else {
            this.$message.error(this.$t('showInfo.获取问卷信息失败'));
          }
          //this.loadingState = false;
        })
        .catch((err) => {
          console.log(err, "err_getConfPaperId");
          //this.loadingState = false;
        });
    },
    /** 编辑问卷 */
    editQuestionnaire() {
      this.$emit("editPaper", this.editPaperObject);
    },
    /**结束发布 */
    finishRelease() {
      this.hintState = "finish";
      this.hintDialogVisible = true;
    },
    /** 结束发布问卷接口函数*/
    finishReleaseApiFunc() {
      //this.loadingState = true;
      finishReleaseApi(
        {
          confId: this.confId,
          confPaperId: this.confPaperId,
        },
        this.$store.getters.liveToken
      ).then((res) => {
        console.log(res, "res_finishRelease");
        if (res.code === 200) {
          //this.actionTabsObj.confPaperId = this.confPaperId;
          //this.$emit("refreshList", true);
          //console.log("finish结束 getConfPaperIdFunc");
          this.getConfPaperIdFunc();
        } else {
          this.$message.error(this.$t('showInfo.结束发布问卷失败！'));
          //this.loadingState = false;
        }
        this.$emit("refreshList", true);
        this.visibleFinish = false;
      });
      // .catch((err) => {
      //   console.log(err, "err_finishRelease");
      //   this.$message.error("结束发布问卷失败！");
      //   this.loadingState = false;
      // });
    },
    /**删除问卷 */
    deleteQuestionnaire() {
      this.hintState = "delete";
      this.hintDialogVisible = true;
    },
    deletQuestionnaireApiFunc() {
      deletQuestionnaireApi(this.confId, this.$store.getters.liveToken)
        .then((res) => {
          console.log(res, "res_deletQuestionnaireApi");
          if (res.code === 200) {
            this.$emit("deleteTo", true);
            // this.questionThis.init()
          }
        })
        .catch((err) => {
          console.log(err, "err_deletQuestionnaireApi");
        });
    },
    /** */
    hintDialogCancel() {
      this.hintDialogVisible = false;
    },
    /** 获取问卷详情 */
    getPaperInfoFunc() {
      getPaperInfo(
        {
          id: this.confId,
        },
        this.$store.getters.liveToken
      )
        .then((res) => {
          console.log(res, "getPaperInfo-----");
          if (res.code === 200) {
            let _data = res.data;
            this.title = _data.title;
            this.dataList = _data.questions;
            this.thirdPartyPaperUri = _data.thirdPartyPaperUri;
            this.paperType = _data.paperType;
            this.questionNaireState = _data.stateV2;
            this.firstRelease = _data.status === 0 ? true : false;
            this.editPaperObject = _data;
            this.forceAnswer = _data.forceAnswer
            console.log(this.editPaperObject, "this.editPaperObject");
          } else {
            this.$message.error(this.$t('showInfo.获取问卷信息失败请检查问卷是否已被删除'));
            this.$emit("refreshList", true);
          }
        })
        .catch((err) => {
          console.log(err, "err_getPaperInfo");
          //this.loadingState = false;
        });
    },
    releaseQuestionnaireFunc() {
      if (this.liveStartStatus != 2) {
        this.$message.error(this.$t('showInfo.请先开启直播'));
        return;
      }
      // 发布问卷
      this.publishLoading = true;
      releaseQuestionnaire(
        {
          id: this.confId,
        },
        this.$store.getters.liveToken
      )
        .then((res) => {
          console.log(res, "res_releaseQuestionnaire");
          if (res.code === 200) {
            this.confPaperId = res.data.confPaperId;
            //this.$emit("refreshList", true);
            //this.getConfPaperIdFunc();
            this.$message.success(this.$t('showInfo.问卷发布成功'));
          }
          this.visibleDel = false;
          this.publishLoading = false;
        })
        .catch((err) => {
          console.log(err, "err_releaseQuestionnaire");
          this.publishLoading = false;
        });
    },

    EndQuestionnaire() {
      // 结束
      let tabs = this.editableTabs;
      tabs.forEach((tab) => {
        if (tab.name === this.editableTabsValue) {
          tab.type = "stop";
        }
      });
      this.editableTabs = tabs;
      let num = this.editableTabsValue * 1 - 2;
      this.TabsHistory[num].type = "stop";
    },
    removeTab(targetName) {
      let tabs = this.editableTabs;
      let activeName = this.editableTabsValue;
      if (activeName === targetName) {
        tabs.forEach((tab, index) => {
          if (tab.name === targetName) {
            let nextTab = tabs[index - 1] || tabs[index + 1];
            if (nextTab) {
              activeName = nextTab.name;
            } else {
              activeName = "1";
            }
          }
        });
      }
      this.editableTabsValue = activeName;
      console.log("ok" + this.editableTabsValue);
      this.editableTabs = tabs.filter((tab) => tab.name !== targetName);
    },
    editIng(index) {
      // 重新編輯
      console.log(index);
      let number = this.editableTabsValue * 1 - 2;
      let list = this.TabsHistory[number].content;
      this.removeTab(index);
      this.AnswerList = [];
      this.AnswerList = list;
      this.tabIndex = this.AnswerList.length;
      this.editableTabsValue = "1";
    },
  },
};
</script>
<style scoped lang="scss">
.third-answer {
  padding-top: 20px;
}
[data-theme='Orange'] .third-answer {
  color: #3e3f41;
}
.rightContent {
  height: 480px;
  width: 100%;
  background: $back-answer-color;
  padding: 20px 0 20px 0;
  font-size: 16px;
  color: $white-color;
}
[data-theme='Orange'] .rightContent {
  color: #3e3f41;
}
.right-con {
  height: 430px;
  text-align: left;
  font-size: 12px;
}
.hintDialogBody {
  min-height: 44px;
  padding: 8px 9px 0 9px;
  font-size: 12px;
  color: #333333;
}
.hintDialogButtton {
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
}
.hintDialog ::v-deep .el-dialog__body {
  padding: 16px 15px;
}
.hintDialog {
  display: flex;
  align-items: center;
}
.question-item {
  margin-top: 20px;
  margin-bottom: 10px;
  h2 {
    font-size: 12px;
    font-weight: normal;
    line-height: 24px;
    display: flex;
    .detail {
      color: $bule-color;
      text-decoration: none;
      margin-left: 10px;
      &:hover {
        color: $bule-color;
      }
    }
  }
}
.detail-item {
  color: $bule-color;
  text-decoration: none;
  position: absolute;
  right: 10px;
  &:hover {
    color: $bule-color;
  }
}
.questionnaire-view {
  padding-right: 15px;
  margin-left: 20px;
}
.questionnaire-view h1 {
  font-size: 16px;
  font-weight: normal;
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 1px dashed #5C617C;
  padding-bottom: 20px;
}
.questionnaire-view h1 i.red {
  background-color: #ff3300;
  color: #ffffff;
}
.questionnaire-view h1 i.black {
  background-color: #666666;
  color: #ffffff;
}
.questionnaire-view h1 i.grey {
  background-color: #dddddd;
  color: #ffffff;
}
.questionnaire-view h1 i {
  font-size: 12px;
  font-weight: normal;
  display: inline-block;
  vertical-align: middle;
  padding: 1px 6px;
  margin-left: 8px;
  border-radius: 2px;
}
.questionnaire-view ul li {
  display: flex;
  align-items: center;
  margin: 10px 0 0 0;
  position: relative;
  .item-question {
    display: inline-block;
    background: #5f6179;
    border-radius: 20px;
    margin: 4px 0;
    padding: 8px 16px;
    width: 60%;
  }
  .item-answer {
    padding-left: 5px;
  }
  .item-question-answer {
    background-repeat: no-repeat;
    background-image: url("../../../assets/images/line.png");
  }
}
::v-deep .el-scrollbar__wrap {
  overflow-x: hidden;
}
.btn-sm {
  border-radius: 4px;
  height: 28px;
  line-height: 28px;
  margin-left: 15px;
  font-size: 12px;
  display: inline-block;
  padding: 0 20px;
  cursor: pointer;
}
.btn-red-outline {
  border: 1px solid $red-color;
  color: $red-color;
  background: transparent;
}
.btn-blue-outline {
  border: 1px solid $bule-color;
  color: $bule-color;
}
.btn-blue-publish {
  border: 1px solid $bule-color;
  background: $bule-color;
  color: #fff;
}
.btn-red-finish {
  background: $red-color;
  float: right;
  margin-top: -4px;
}
.font-blue {
  color: $bule-color;
  margin: 0 5px;
}
.bottom-bar {
  padding-right: 15px;
  margin-left: 20px;
}
.questionnaire-control {
  font-size: 12px;
  text-align: right;
}
.bottom-divider {
  margin: 0 0 20px 0;
}
.end {
  text-align: left;
}
.question {
  overflow-x: hidden;
}
::v-deep .el-dialog__body {
  padding-left: 0;
  padding-right: 0;
}
.scale-item {
  &-title {
    display: flex;
    justify-content: space-around;
    height: 30px;
    align-items: center;
    margin: 10px 0;
  }
  &-left {
    flex-grow: 1;
  }
  &-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
  }
  &-score {
    width: 100%;
    display: inline-block;
    text-align: center;
    height: 20px;
    line-height: 20px;
    border: 1px solid #aab0bd;
  }
  &-other {
    margin-right: 5px;
  }
  &-row {
    flex-grow: 1;
  }
  &-start {
    border-radius: 3px 0px 0px 3px;
  }
  &-end {
    border-radius: 0 3px 3px 0;
  }
}

.url {
  margin-right: 5px;
}
.scale-type {
  width: 14px;
  height: 14px;
  border: 1px solid #fff;
  border-radius: 14px;
  float: left;
}
[data-theme='Orange'] .scale-type {
  border: 1px solid #3E3F41;
}
.forceanswer-icon{
  vertical-align: sub;
  margin-right: 5px;
}
.requiredTips{
  display: inline-block;
  border-bottom: 1px solid;
  width: 80px;
  margin-left: 6px;
}
</style>
<style lang="scss">
.el-popover {
  background: $back-answer-color;
  color: rgba(255, 255, 255, 0.65);
  border: 1px solid $back-answer-color;
  box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.2);
}
.el-popper[x-placement^="top"] .popper__arrow,
.el-popper[x-placement^="top"] .popper__arrow::after {
  border-top-color: $back-answer-color;
}

</style>
